
<div>
  <div class="form-group">
    <p class="info-text">
      <i class="fas fa-info-circle mr-2"></i>This report shows all delinked accounts for your firm.
    </p>
  </div>

  <div class="button-group">
    <button type="button" class="btn btn-outline-secondary action-button" @click="generateReport">
      <i class="fas fa-download mr-2"></i>Download Report
    </button>
  </div>
</div>
